module.exports = __webpack_public_path__ + "58a8fb0eb2069e85b0bdcfae75d242df.svg";